import React from "react";
import iconCoin from "../../../../../assets/images/Mini-Game/attempt-coin.svg";
import iconBid from "../../../../../assets/images/Mini-Game/new-year-2025/bid.png";
import { useTranslation } from "react-i18next";
import { useNewYear2025Theme } from "../../../../../helper/const";
import styled from "styled-components";

export default function CardChange({
  bid,
  setBid,
  bidTotal,
  handleTurnMini,
  userInfo,
  showDataLogin,
  handleToBuyTurn,
}) {
  const { t } = useTranslation();
  const handleChangeBid = (type) => {
    if (!userInfo) {
      return showDataLogin();
    }
    if (!bidTotal) {
      return null;
    }
    if (type === "add") {
      return setBid(bid + 1);
    }

    if (bid !== 1) {
      setBid(bid - 1);
    }
  };

  const IS_EVENT_NEW_YEAR_2025_THEME = useNewYear2025Theme();

  return (
    <div
      className={`container-change-coin-minigame ${
        IS_EVENT_NEW_YEAR_2025_THEME ? "new-year-25-theme" : ""
      }`}
    >
      <div className='header-change-coin'>
        <img
          src={IS_EVENT_NEW_YEAR_2025_THEME ? iconBid : iconCoin}
          alt='coin'
          className='icon-coin-change'
        />
        <div className='content-change-coin'>
          {t("mini_game.standard_missions.1_turn_1_coin")}
        </div>
      </div>
      <div class='dashed-line' />
      <div className='change-turn'>
        <div className='btn-container'>
          <button onClick={() => handleChangeBid("minus")}>-</button>
          <input className='btn-total' value={bid} />
          <button onClick={() => handleChangeBid("add")}>+</button>
        </div>
        <button
          onClick={handleTurnMini}
          className={`btn-change-turn btn-change-turn__mini ${
            bidTotal === 0 || bidTotal < bid
              ? "disable-button-change-turn"
              : "scale-hover-item"
          }`}
        >
          {`${t("mini_game.standard_missions.change_turns")
            .replace("X", bid)
            .replace("turns", +bid > 1 ? "turns" : "turn")}`}
        </button>
      </div>

    </div>
  );
}
